import {useAuthAxios} from 'hooks/api/useAuthAxios'

export const useUpdateProcedureStatus = () => {
  const authAxios = useAuthAxios()

  return async (procedureStatusId: string, params: {dateOn?: string; initialized?: boolean}) => {
    return authAxios.put(`/api/procedure_statuses/${procedureStatusId}`, {
      date_on: params.dateOn,
      initialized: params.initialized,
    })
  }
}
